// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__17-mf","btn_menu":"Nav_btn_menu__2ndSa","img":"Nav_img__Y2fIw","showMenu":"Nav_showMenu__b5UII","menuMovil":"Nav_menuMovil__MgPGR"};